import store from "@/services/store";
function valueService(items,indexGet) 
{		
		var list_novedad = store.state.crudStore.dataGet.informes_aportes.data[indexGet].archivo_plano.id_list_novedad
		if(list_novedad===1)
		{
			return items.valoringreso	
		}
		if(list_novedad===2 || list_novedad===4)
		{
			
			return items.valor	
		}
		if(list_novedad===3)
		{
			return items.valorretiro	
		}
	
	return null
  }
export default {
	data(){
		return {
			tableGBoptions: { 

			},

			tableGBSearch: ['datos_afiliado/documento','datos_afiliado/name','datos_asesor/name'],
			
			tableGBItems: [
				{
					thead: { th: 'Documento'},
					tbody: { td: ['archivo_plano/documento'], campos: ['archivo_plano/id']}
				},
				{
					thead: { th: 'Nombre', sort: null, sortTable: 'datos_afiliado/name'},
					tbody: { td: ['datos_afiliado/name'],}
				},
				{
					thead: { th: 'Asesor', },
					tbody: { td: ['datos_asesor/name'],}
				},
				{
					thead: { th: 'Razón', sort: null, sortTable: 'datos_razon/name' },
					tbody: { td: ['datos_razon/name'],}
				},
				{
					thead: { th: 'Servicios', },
					tbody: { td: ['archivo_plano/servicios'],}
				},
				{
					thead: { th: 'Periodo', },
					tbody: { td: ['list_mes/name','list_ano/name']}
				},
				{
					thead: { th: 'Registro'},
					tbody: {td: ['archivo_plano/id_info_aportes'], link: '/api/pdf/registroaportes'},
				},
				{
					thead: { th: 'Planilla'},
					tbody: {td: ['archivo_plano/planilla']},
				},
				{
					thead: { th: 'Fecha Planila', },
					tbody: { td: ['archivo_plano/fechaplanilla'],}
				},
				{
					thead: { th: 'Sol.', sort: null, sortTable: 'datos_afiliado/planilla'},
					tbody: {td: ['datos_afiliado/planilla'], ftn: function(value){ if(value===1) return 'SI'}},
				},
			],			
		
		}
	},
}